import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ModalModule } from '../modal/modal.module';
import { SharedModule } from '../shared/shared.module';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { InternetExplorerComponent } from './components/internet-explorer/internet-explorer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { IEGuard } from './guards/ie.guard';
import { LanguageGuard } from './guards/language.guard';
import { MobileGuard } from './guards/mobile.guard';
import { ColorsService } from './services/colors.service';
import { NotificationsService } from './services/notifications.service';
import { ProjectApiService } from './services/project-api.service';
import { ProjectHistoryService } from './services/project-history.service';
import { ProjectResolver } from './services/project.resolver';
import { ProjectService } from './services/project.service';
import { SharedProjectResolver } from './services/shared-project.resolver';
import { UserApiService } from './services/user-api.service';
import { UserResolver } from './services/user.resolver';
import { UserService } from './services/user.service';
import { WhiteLabelResolver } from './services/white-label.resolver';
import { ImportExportService } from './services/import-export.service';
import { TransService } from './services/trans.service';
import { PalletOverflowRecommendationService } from './services/pallet-overflow-recommendation.service';

@NgModule({ declarations: [
        ErrorPageComponent,
        InternetExplorerComponent,
        LoaderComponent,
    ],
    exports: [ErrorPageComponent, InternetExplorerComponent], imports: [CommonModule,
        TranslateModule.forRoot(),
        SharedModule,
        ModalModule], providers: [
        ImportExportService,
        ProjectService,
        ProjectApiService,
        ProjectResolver,
        ProjectHistoryService,
        SharedProjectResolver,
        ColorsService,
        UserService,
        UserApiService,
        LanguageGuard,
        CookieService,
        IEGuard,
        DatePipe,
        MobileGuard,
        UserResolver,
        NotificationsService,
        WhiteLabelResolver,
        TransService,
        PalletOverflowRecommendationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {
  constructor(palletOverflowRecommendation: PalletOverflowRecommendationService) {
    void palletOverflowRecommendation;
  }
}
